const SINGLE_PAYMENT_TOKEN_KEY = 'single_payment.auth_token';
const SINGLE_PAYMENT_ID_KEY = 'single_payment.id';

type SinglePaymentSessionContext = {
  singlePaymentId?: string | null;
  token?: string | null;
};

function getSessionStorage(): Storage | null {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    return window.sessionStorage;
  } catch (error) {
    return null;
  }
}

function readSessionValue(key: string): string | null {
  return getSessionStorage()?.getItem(key) ?? null;
}

function writeSessionValue(key: string, value: string): void {
  getSessionStorage()?.setItem(key, value);
}

function normalizeSessionValue(value: string | null | undefined): string | null {
  const normalizedValue = String(value ?? '').trim();

  return normalizedValue === '' ? null : normalizedValue;
}

export function getSinglePaymentToken(): string | null {
  return readSessionValue(SINGLE_PAYMENT_TOKEN_KEY);
}

export function setSinglePaymentToken(token: string): void {
  writeSessionValue(SINGLE_PAYMENT_TOKEN_KEY, token);
}

export function getSinglePaymentId(): string | null {
  return readSessionValue(SINGLE_PAYMENT_ID_KEY);
}

export function setSinglePaymentId(singlePaymentId: string): void {
  writeSessionValue(SINGLE_PAYMENT_ID_KEY, singlePaymentId);
}

export function hasSinglePaymentSession(): boolean {
  return Boolean(getSinglePaymentId() || getSinglePaymentToken());
}

export function resolveSinglePaymentSession(
  context: SinglePaymentSessionContext = {}
): { singlePaymentId: string | null; token: string | null } {
  const singlePaymentId = normalizeSessionValue(context.singlePaymentId);
  const token = normalizeSessionValue(context.token);

  if (singlePaymentId) {
    setSinglePaymentId(singlePaymentId);
  }

  if (token) {
    setSinglePaymentToken(token);
  }

  return {
    singlePaymentId: singlePaymentId ?? getSinglePaymentId(),
    token: token ?? getSinglePaymentToken()
  };
}

export function buildSinglePaymentFormPath(singlePaymentId: string): string {
  const params = new URLSearchParams({
    single_payment_id: singlePaymentId
  });
  const token = getSinglePaymentToken();

  if (token) {
    params.set('token', token);
  }

  return `/formulario/single_payment?${params.toString()}`;
}
